import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
  ReactElement,
  CSSProperties,
} from 'react';

import COLORS from '~/constants/colors';

interface CodeProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  highlight?: string;
  style?: CSSProperties;
}

function Code({
  highlight = COLORS.alto,
  style,
  children,
  ...props
}: PropsWithChildren<CodeProps>): ReactElement {
  const codeStyle = {
    padding: '0.3em',
    fontSize: '0.9em',
    borderRadius: '0.3em',
    color: COLORS.black,
    backgroundColor: `${highlight}88`,
    ...style,
  };

  return (
    <code style={codeStyle} {...props}>
      {children}
    </code>
  );
}

export default Code;
